import { useNavigate } from "react-router-dom";
import { useTheme } from "@/context/ThemeContext";
import FunToolsGrid from "../components/FunToolsGrid";
import ExperienceShell from "../ExperienceShell";
import {
  AVAILABLE_FUN_TOOL_IDS,
  experienceFunToolPath,
  isAvailableFunTool,
} from "../routes";

export default function FunExperiencePage() {
  const { effectiveTheme } = useTheme();
  const navigate = useNavigate();

  const handleOpenTool = (toolId: string) => {
    if (!isAvailableFunTool(toolId)) return false;
    navigate(experienceFunToolPath(toolId));
    return true;
  };

  return (
    <ExperienceShell activeId="fun" contentKey="fun-grid">
      <FunToolsGrid
        isLight={effectiveTheme === "light"}
        onOpenTool={handleOpenTool}
        availableToolIds={AVAILABLE_FUN_TOOL_IDS}
      />
    </ExperienceShell>
  );
}
